import React, { useEffect } from 'react'
import Choice from '../../Choice/Choice'
import Rock from "../../../assets/images/icon-rock.svg"
import { flushState, resultDesicide, scoreComputation, setComputerChoice } from '../../../Redux/Game/gameActions'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { computerchoiceSelector, resultSelector, scoreSelector } from '../../../Redux/Game/gameSelector'

const Result = ({ choice, computerChoice,score,flushState, scoreComputation, computerchoiceSelector, resultDecide, result }) => {

    const { variant } = choice
    const computerVariant = computerchoiceSelector?.variant


    useEffect(() => {
        if (choice.variant) {

            computerChoice()

        }

    }, [variant])


    useEffect(() => {
        if (computerVariant) {
            if (choice.variant === "rock") {
                if (computerchoiceSelector?.variant == "scissors") {
                    resultDecide("win")
                    scoreComputation("win")
                }
                else if (computerchoiceSelector?.variant === "rock") {
                    resultDecide("draw")
                }
                else {
                    resultDecide("lose")
                    scoreComputation("lose")

                    

                }
            } else if (choice.variant === "paper") {
                if (computerchoiceSelector?.variant === "rock") {
                    resultDecide("win")
                    scoreComputation("win")


                }
                else if (computerchoiceSelector?.variant === "paper") {
                    resultDecide("draw")
                }
                else {
                    resultDecide("lose")
                    scoreComputation("lose")


                }
            } else {
                if (computerchoiceSelector?.variant === "paper") {
                    resultDecide("win")
                    scoreComputation("win")


                }
                else if (computerchoiceSelector?.variant === "scissors") {
                    resultDecide("draw")
                }
                else {
                    resultDecide("lose")
                    scoreComputation("lose")

                }
            }
        }

    }, [computerVariant])


    return (
        <>
            <div className="mt-32 max-w-xl mx-auto flex justify-around">
                <div className="flex flex-col items-center gap-2">
                    <Choice variant={choice.variant}>
                        <img src={choice.image} />
                    </Choice>
                    <p className="text-white text-xl">You Picked</p>
                </div>
                <div className="flex flex-col items-center justify-center gap-2">
                    <Choice variant={computerchoiceSelector?.variant} disabled>
                        <img src={computerchoiceSelector?.image}></img>
                    </Choice>
                    <p className="text-white text-xl text-center">Computer Picked</p>
                </div>
            </div>
            <div className='mt-4 flex justify-center tracking-theWidest'>
                <p className='text-white text-4xl'>{result?.toUpperCase()}</p>
            </div>
            <div className='mt-4 flex justify-center tracking-theWidest'>
                <button onClick={() => {
                    flushState()
                }} className='bg-white rounded px-4 py-2 text-xl mt-6'>REMATCH</button>
            </div>
        </>
    )
}

const mapDispatchToProps = dispatch => ({
    computerChoice: () => dispatch(setComputerChoice()),
    resultDecide: (res) => dispatch(resultDesicide(res)),
    flushState: () => dispatch(flushState()),
    scoreComputation: (res) => dispatch(scoreComputation(res))
})

const mapStateToProps = createStructuredSelector({
    computerchoiceSelector: computerchoiceSelector,
    result: resultSelector,
    score : scoreSelector
})

export default connect(mapStateToProps, mapDispatchToProps)(Result)